import SiteHeader, { MAIN_CONTENT_ID } from '@components/shared/header/SiteHeader'
import Footer from '@components/salon/SalonFooter'

import styles from 'styles/Main.module.css'

const SalonLayout = ({ children, nofooterdiv }) => <>
    <SiteHeader logoOnly />
    <main className={styles.main} id={MAIN_CONTENT_ID}>
        { children }
        <Footer nodiv={nofooterdiv} />
    </main>
</>

function NavSpace (props) {
    return <div className={styles['nav-space']} {...props} />
}

SalonLayout.NavSpace = NavSpace

export default SalonLayout